import { BsWhatsapp } from "react-icons/bs";

export const WhatsAppButton = () => {
	return (
		<a
			href="https://wa.me/27699042846"
			target="_blank"
			rel="noopener noreferrer"
			className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center group"
			aria-label="Chat on WhatsApp"
		>
			<BsWhatsapp className="text-3xl" />
			<span className="absolute right-full mr-3 bg-gray-800 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
				Chat with us
			</span>
		</a>
	);
};
